import React from "react";

import styled from "styled-components";

import { ReactComponent as Icon } from "assets/icons/chatIcon.svg";

type Props = {
  isActive?: boolean;
  disabled?: boolean;
};

export function ChatIcon({ isActive, disabled }: Props) {
  return <StyledIcon $isActive={isActive} $disabled={disabled} />;
}
const StyledIcon = styled(Icon)<{ $isActive?: boolean; $disabled?: boolean }>`
  path {
    fill: ${({ theme, $isActive, $disabled }) =>
      $isActive
        ? theme.palette.purpleDark
        : $disabled
          ? theme.palette.neutralLight
          : theme.palette.black};
  }
`;
